module.exports = __webpack_public_path__ + "img/workspace-onboarding/upload-a-video-9b6948b497bab2dbb71b947b9568c68c.png";